import React from 'react';
import { t } from '@lingui/macro';

import OverflowTextModal from '@rover/components/src/OverflowTextModal/OverflowTextModal';
import { Box } from '@rover/kibble/core';

import { SitterProfileVersionOptions } from '../../constants';
import { sendSectionInteractionEvent } from '../../utils/sendSectionInteractionEvent';

type Props = {
  dogsExperience: string | undefined;
};

const RevampTypicalDay = ({ dogsExperience }: Props): JSX.Element | null => {
  if (!dogsExperience) return null;

  return (
    <Box width="100%" data-testid="revamp-typical-day" py="6x">
      <OverflowTextModal
        title={t`A typical day`}
        text={dogsExperience}
        onReadMore={() => {
          sendSectionInteractionEvent('dogExperience', {
            interactionType: 'expand',
            pageVariant: SitterProfileVersionOptions.REVAMP,
          });
        }}
      />
    </Box>
  );
};

export default RevampTypicalDay;
